import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TableRow, TableCell, Box, Typography, Link } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import theme from '../../../theme';

const SortableBannerRow = ({ banner, cellStyle, textStyle }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: banner.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <TableRow ref={setNodeRef} style={style} {...attributes} hover>
      <TableCell sx={{ ...cellStyle, cursor: 'grab', p: 0, touchAction: 'none' }} {...listeners}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <DragIndicatorIcon sx={{ color: theme.palette.black[3] }} />
        </Box>
      </TableCell>
      <TableCell
        align="center"
        sx={{ ...cellStyle, minWidth: 306, width: 306, height: 46, p: 0, overflow: 'hidden' }}
      >
        <Box
          component="img"
          src={banner.appConfig?.imageUrl || banner.imageUrl}
          alt={banner.title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </TableCell>
      <TableCell sx={{ ...cellStyle, minWidth: 300, width: 300 }}>
        <Typography {...textStyle}>{banner.appConfig?.headline || banner.title}</Typography>
      </TableCell>
      <TableCell sx={cellStyle}>
        <Link
          href={banner.url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textDecoration: 'none' }}
        >
          <Typography
            {...textStyle}
            sx={{
              maxWidth: 300,
              width: 300,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {banner.url}
          </Typography>
        </Link>
      </TableCell>
      <TableCell align="right">
        <Typography {...textStyle}>{banner.clickCount.toLocaleString()}</Typography>
      </TableCell>
    </TableRow>
  );
};

export default SortableBannerRow;
